import { Button } from '@mui/material';
import theme from '../../theme';

const MoreButton = ({ onClick, children = '더보기', ...props }) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      disableRipple
      sx={{
        width: { xs: 99, md: 140 },
        minHeight: { xs: 34, md: 36 },
        borderRadius: '20px',
        borderColor: theme.palette.black[9],
        color: theme.palette.black[9],
        fontSize: { xs: 14, md: 16 },
        fontWeight: 500,
        lineHeight: 1,
        padding: 0,
        '&:hover': {
          borderColor: theme.palette.black[9],
          backgroundColor: 'transparent',
        },
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default MoreButton;
